// Mock data para cotizaciones de seguros
export interface InsuranceQuote {
	id: string
	company: string
	companyLogo: string
	price: number
	recommended?: boolean
	coverage: {
		cargoInstalacion: string | boolean
		garantiaSatisfaccion: boolean
		soporte24_7: boolean
		monitoreoEnergia: boolean
		fuentesRenovables: string
		compensacionCarbono: string
	}
}

export const mockQuotes: InsuranceQuote[] = [
	{
		id: 'sancor-1',
		company: 'Sancor Seguros',
		companyLogo: '/img/insurance/sancor-logo.svg',
		price: 145279,
		recommended: true,
		coverage: {
			cargoInstalacion: '$119',
			garantiaSatisfaccion: true,
			soporte24_7: false,
			monitoreoEnergia: false,
			fuentesRenovables: '50%',
			compensacionCarbono: '1.5 toneladas métricas de CO2e',
		},
	},
	{
		id: 'zurich-1',
		company: 'Zurich',
		companyLogo: '/img/insurance/zurich-logo.svg',
		price: 152890,
		coverage: {
			cargoInstalacion: 'Sin Cargo de Instalación',
			garantiaSatisfaccion: true,
			soporte24_7: true,
			monitoreoEnergia: true,
			fuentesRenovables: '75%',
			compensacionCarbono: '5 toneladas métricas de CO2e',
		},
	},
	{
		id: 'prevencion-1',
		company: 'Prevención ART',
		companyLogo: '/img/insurance/prevencion-logo.svg',
		price: 138450,
		coverage: {
			cargoInstalacion: 'Sin Cargo de Instalación',
			garantiaSatisfaccion: true,
			soporte24_7: true,
			monitoreoEnergia: true,
			fuentesRenovables: '90%',
			compensacionCarbono: 'Personalizado',
		},
	},
	{
		id: 'sancor-2',
		company: 'Sancor Seguros',
		companyLogo: '/img/insurance/sancor-logo.svg',
		price: 158200,
		coverage: {
			cargoInstalacion: 'Sin Cargo de Instalación',
			garantiaSatisfaccion: true,
			soporte24_7: true,
			monitoreoEnergia: false,
			fuentesRenovables: '60%',
			compensacionCarbono: '3 toneladas métricas de CO2e',
		},
	},
	{
		id: 'zurich-2',
		company: 'Zurich',
		companyLogo: '/img/insurance/zurich-logo.svg',
		price: 145279,
		coverage: {
			cargoInstalacion: '$99',
			garantiaSatisfaccion: true,
			soporte24_7: false,
			monitoreoEnergia: true,
			fuentesRenovables: '70%',
			compensacionCarbono: '4 toneladas métricas de CO2e',
		},
	},
	{
		id: 'prevencion-2',
		company: 'Prevención ART',
		companyLogo: '/img/insurance/prevencion-logo.svg',
		price: 149990,
		coverage: {
			cargoInstalacion: 'Sin Cargo de Instalación',
			garantiaSatisfaccion: true,
			soporte24_7: true,
			monitoreoEnergia: true,
			fuentesRenovables: '85%',
			compensacionCarbono: '6 toneladas métricas de CO2e',
		},
	},
	{
		id: 'sancor-3',
		company: 'Sancor Seguros',
		companyLogo: '/img/insurance/sancor-logo.svg',
		price: 142100,
		coverage: {
			cargoInstalacion: '$150',
			garantiaSatisfaccion: true,
			soporte24_7: false,
			monitoreoEnergia: false,
			fuentesRenovables: '55%',
			compensacionCarbono: '2 toneladas métricas de CO2e',
		},
	},
	{
		id: 'zurich-3',
		company: 'Zurich',
		companyLogo: '/img/insurance/zurich-logo.svg',
		price: 155600,
		coverage: {
			cargoInstalacion: 'Sin Cargo de Instalación',
			garantiaSatisfaccion: true,
			soporte24_7: true,
			monitoreoEnergia: true,
			fuentesRenovables: '80%',
			compensacionCarbono: '5.5 toneladas métricas de CO2e',
		},
	},
]
